// Dependencies
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import Modal from 'react-modal';

// Redux Store
import configureStore from './shared/configureStore';

// Containers
import App from './App';

// Service Worker
import * as serviceWorker from './serviceWorker';

// Assets
import './index.css';


// Configure Redux Store
const store = configureStore({}); //window.initialState);

// DOM
const rootElement = document.getElementById('root');

// App Wrapper
const renderApp = Component => {
  render(
    <IntlProvider locale="en">
      <Provider store={store}>
        <Component />
      </Provider>
    </IntlProvider>,
    rootElement
  );
};

// React Modal config
Modal.setAppElement('#root');

// Rendering App
renderApp(App);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

